<div class="video-info-detail">
  <div
    class="live-box"
    *ngIf="
      videoDetail?.type === 'live' && videoDetail?.channel_content?.start_time
    "
  >
    <h5 *ngIf="!videoDetail.showTimer">Coming Up In</h5>
    <countdown
      *ngIf="!videoDetail.showTimer"
      #cd
      [config]="videoDetail | timerValue"
      (event)="VideoDetailComponent.handleEvent($event)"
    ></countdown>

    <span class="live-tag" *ngIf="videoDetail.showTimer"> Live </span>
  </div>
  <div class="video-info">
    <div class="d-flex align-items-start all-btns-box">
      <div class="user-btns d-flex">
        <!-- <div class="text-center mr-2">
          <button class="btn btn-theme">
            <i class="mdi mdi-play"></i>
          </button>
          <p class="mb-0">Watch Now</p>
        </div> -->
        <div *ngIf="isLogin" class="text-center mr-2 watch-btn">
          <button
            (click)="favoriteVideo()"
            class="btn btn-white-border"
            [ngClass]="{ favorite: videoDetail?.is_favorite?.id }"
          >
            <span class="spin icon-loader mr-0" *ngIf="isLoading"> </span>
            <span
              *ngIf="!isLoading"
              class="social-icon"
              [ngClass]="{
                'mdi mdi-text-box-check-outline': videoDetail?.is_favorite?.id,
                'icon-plus': !videoDetail?.is_favorite?.id
              }"
            ></span>
          </button>
          <p class="mb-0" *ngIf="videoDetail?.is_favorite?.id && !isLoading">
            {{ "VIDEO_DETAIL.ADDED_TO_LIST" | translate }}
          </p>
          <p class="mb-0" *ngIf="!videoDetail?.is_favorite?.id && !isLoading">
            {{ "VIDEO_DETAIL.ADD_TO_LIST" | translate }}
          </p>
        </div>
        <div *ngIf="!isLogin" class="text-center mr-2 watch-btn">
          <button
            [matMenuTriggerFor]="watch"
            matTooltip="Watchlist"
            class="btn btn-white-border"
            [ngClass]="{ favorite: videoDetail?.is_favorite?.id }"
            (click)="favoriteVideo()"
          >
            <span class="spin icon-loader mr-0" *ngIf="isLoading"> </span>

            <span
              *ngIf="!isLoading"
              class="social-icon mr-2"
              [ngClass]="{
                'mdi mdi-text-box-check-outline': videoDetail?.is_favorite?.id,
                'icon-plus': !videoDetail?.is_favorite?.id
              }"
            ></span>
          </button>
          <p class="mb-0" *ngIf="videoDetail?.is_favorite?.id && !isLoading">
            {{ "VIDEO_DETAIL.ADDED_TO_LIST" | translate }}
          </p>
          <p class="mb-0" *ngIf="!videoDetail?.is_favorite?.id && !isLoading">
            {{ "VIDEO_DETAIL.ADD_TO_LIST" | translate }}
          </p>
        </div>
        <div>
          <mat-menu #watch="matMenu" class="please_login">
            <div (click)="$event.stopPropagation()">
              <h4>{{ "VIDEO_DETAIL.WATCH_AGAIN" | translate }}</h4>
              <p>{{ "VIDEO_DETAIL.ADD_PLAYLIST" | translate }}</p>
              <hr />
              <a href="javascript:void(0)" (click)="singIn('is_favorite')">
                {{ "VIDEO_DETAIL.SIGN_IN" | translate }}
              </a>
            </div>
          </mat-menu>
        </div>
      </div>
      <div class="d-flex align-items-start icons-box">
        <div
          matTooltip="{{ 'VIDEO_DETAIL.LIKE_TIP' | translate }}"
          class="social-icons"
          *ngIf="isLogin"
        >
          <button
            [disabled]="videoDetail?.likeDislikeDisable == 1"
            (click)="likeDislike(1)"
            mat-button
            [ngClass]="{ favorite: videoDetail?.is_user_likeDislike == 1 }"
          >
            <span
              class="social-icon"
              [ngClass]="{
                'icon-like-border':
                  !likeLoader &&
                  (videoDetail?.is_user_likeDislike == 0 ||
                    videoDetail?.is_user_likeDislike == null),
                'icon-like':
                  videoDetail?.is_user_likeDislike == 1 && !likeLoader
              }"
            >
              <span [ngClass]="{ 'spin icon-loader': likeLoader }"> </span>
            </span>
            <span *ngIf="!likeLoader" class="social-h"
              >{{ videoDetail?.total_like }}
            </span>
          </button>
        </div>
        <div
          matTooltip="{{ 'VIDEO_DETAIL.LIKE_TIP' | translate }}"
          class="social-icons"
          *ngIf="!isLogin"
        >
          <button
            [matMenuTriggerFor]="like"
            [disabled]="videoDetail?.likeDislikeDisable == 1"
            (click)="likeDislike(1)"
            mat-button
            [ngClass]="{ favorite: videoDetail?.is_user_likeDislike == 1 }"
          >
            <span
              class="social-icon"
              [ngClass]="{
                'icon-like-border':
                  videoDetail?.is_user_likeDislike == 0 ||
                  videoDetail?.is_user_likeDislike == null,
                'icon-like': videoDetail?.is_user_likeDislike == 1
              }"
            ></span>
            <span class="social-h">{{ videoDetail?.total_like }} </span>
          </button>

          <mat-menu #like="matMenu" class="please_login">
            <div (click)="$event.stopPropagation()">
              <h4>{{ "VIDEO_DETAIL.LIKE_THIS_VIDEO" | translate }}</h4>
              <p>{{ "VIDEO_DETAIL.SIGNIN_MESSAGE" | translate }}</p>
              <hr />
              <a href="javascript:void(0)" (click)="singIn('like')">
                {{ "VIDEO_DETAIL.SIGN_IN" | translate }}</a
              >
            </div>
          </mat-menu>
        </div>
        <div
          matTooltip="{{ 'VIDEO_DETAIL.DISLIKE_TIP' | translate }}"
          class="social-icons"
          *ngIf="isLogin"
        >
          <button
            [disabled]="videoDetail?.likeDislikeDisable == 0"
            (click)="likeDislike(0)"
            mat-button
            [ngClass]="{ favorite: videoDetail?.is_user_likeDislike == 0 }"
          >
            <span
              class="social-icon"
              [ngClass]="{
                'icon-dis-like-border':
                  !dislikeLoader &&
                  (videoDetail?.is_user_likeDislike == 1 ||
                    videoDetail?.is_user_likeDislike == null),
                'icon-dis-like':
                  videoDetail?.is_user_likeDislike == 0 && !dislikeLoader
              }"
            >
              <span [ngClass]="{ 'spin icon-loader': dislikeLoader }"> </span>
            </span>
            <span *ngIf="!dislikeLoader" class="social-h">{{
              videoDetail?.total_dislike
            }}</span>
          </button>
        </div>
        <div
          matTooltip="{{ 'VIDEO_DETAIL.DISLIKE_TIP' | translate }}"
          class="social-icons"
          *ngIf="!isLogin"
        >
          <button
            [matMenuTriggerFor]="dislike"
            [disabled]="videoDetail?.likeDislikeDisable == 0"
            (click)="likeDislike(0)"
            mat-button
            [ngClass]="{ favorite: videoDetail?.is_user_likeDislike == 0 }"
          >
            <span
              class="social-icon"
              [ngClass]="{
                'icon-dis-like-border':
                  videoDetail?.is_user_likeDislike == 1 ||
                  videoDetail?.is_user_likeDislike == null,
                'icon-dis-like': videoDetail?.is_user_likeDislike == 0
              }"
            ></span>
            <span class="social-h">{{ videoDetail?.total_dislike }}</span>
          </button>
          <mat-menu #dislike="matMenu" class="please_login">
            <div (click)="$event.stopPropagation()">
              <h4>{{ "VIDEO_DETAIL.DONT_LIKE_THIS_VIDEO" | translate }}</h4>
              <p>{{ "VIDEO_DETAIL.SIGNIN_MESSAGE" | translate }}</p>
              <hr />
              <a href="javascript:void(0)" (click)="singIn('dislike')">
                {{ "VIDEO_DETAIL.SIGN_IN" | translate }}
              </a>
            </div>
          </mat-menu>
        </div>
        <div class="social-icons" *ngIf="videoDetail?.type == 'series'">
          <button
            matTooltip="{{ 'VIDEO_DETAIL.REMINED_ME_TIP' | translate }}"
            [disabled]="videoDetail?.remindStatus == 'true'"
            mat-button
            [ngClass]="{ favorite: videoDetail.is_remindMe == 'yes' }"
          >
            <span
              class="social-icon icon-notification"
              [ngClass]="{
                'icon-notification-fill': videoDetail?.is_remindMe === 'yes'
              }"
              (click)="remindMe()"
            ></span>
          </button>
        </div>
      </div>
    </div>

    <div class="m-0 row align-items-center">
      <div class="video-details">
        <p class="mb-0" *ngIf="videoDetail?.genres?.length > 0">
          <span class="ganner-name" *ngFor="let data of videoDetail?.genres">
            {{ data.name }}
          </span>
        </p>
        <h1 class="text-capitalize" *ngIf="videoDetail?.type == 'video'">
          {{ videoDetail?.name }}
        </h1>
        <h1 class="text-capitalize" *ngIf="videoDetail?.type == 'series'">
          {{ videoDetail?.series_title }}
        </h1>
        <h4 class="font-bold mb-2" *ngIf="videoDetail?.type == 'series'">
          <span *ngIf="videoDetail.season_number">
            S {{ videoDetail.season_number }}</span
          >
          <span *ngIf="videoDetail.episod_number >= 0">
            E {{ videoDetail?.episod_number + 1 }} :</span
          >
          {{ videoDetail?.name }}
        </h4>
        <h6 class="pb-2">
          {{ videoDetail?.duration ? (videoDetail?.duration | second_time) : ""
          }}{{ videoDetail?.published_year && videoDetail.duration ? "," : "" }}
          {{ videoDetail?.published_year ? videoDetail?.published_year : "" }}
          <span class="adult-no" *ngIf="videoDetail?.is_adult == 1">18+</span>
          <span
            *ngIf="
              videoDetail?.source === 'system' && videoDetail?.omdb_ratings
            "
          >
            <span class="imd-batch">OMDb </span>
            <span class="ml-1">{{ videoDetail?.omdb_ratings }}</span></span
          >
        </h6>
        <p class="content-desk">
          {{
            videoDetail.description | removeUnderScore | slice: 0:sliceLength
          }}
          <a
            href="javascript:void(0)"
            class="orange-link"
            *ngIf="videoDetail.description.length > 410"
            (click)="descriptionLength()"
          >
            <span *ngIf="sliceLength == 410">...Read more </span>
            <span *ngIf="sliceLength > 410">...Read less </span>
          </a>
        </p>
        <div class="main-details">
          <h6 *ngIf="videoDetail?.director?.length > 0">
            <span>{{ "VIDEO_DETAIL.DIRECTORS" | translate }}</span
            >{{ videoDetail?.director | titlecase }}
          </h6>
          <h6 *ngIf="videoDetail?.published_year?.length > 0">
            <span>{{ "VIDEO_DETAIL.PUBLISHED_YEAR" | translate }}</span>
            {{ videoDetail?.published_year }}
          </h6>
          <h6 *ngIf="videoDetail?.language_subtitle?.length > 0">
            <span>{{ "VIDEO_DETAIL.SUBTITLES" | translate }}</span>
            {{ videoDetail?.language_subtitle | titlecase }}
          </h6>
          <h6 *ngIf="videoDetail?.language?.length > 0">
            <span>{{ "VIDEO_DETAIL.AUDIO_LANGUAGES" | translate }}</span>
            {{ videoDetail?.language | titlecase }}
          </h6>
          <h6 *ngIf="videoDetail?.actors?.length > 0">
            <span>{{ "VIDEO_DETAIL.ACTORS" | translate }}</span>
            {{ videoDetail?.actors | titlecase }}
          </h6>
          <div *ngIf="videoDetail?.content_more_detail">
            <h6 *ngFor="let moreDetail of videoDetail?.content_more_detail">
              <span>{{ moreDetail?.name | titlecase }}</span>
              {{ moreDetail.value | titlecase }}
            </h6>
          </div>
        </div>
      </div>
      <div class="report-btn-box">
        <div
          *ngIf="videoDetail?.source == 'system' && isLogin"
          class="social-icons"
        >
          <button
            matTooltip="{{ 'VIDEO_DETAIL.SHARE_TIP' | translate }}"
            mat-button
            class="link-btn"
            aria-label="Example icon-button with a menu"
            (click)="openShareVideoContent()"
          >
            <span class="icon-forword"></span> Share
          </button>
        </div>
        <div
          *ngIf="videoDetail?.source == 'system' && !isLogin"
          class="social-icons"
        >
          <button
            [matMenuTriggerFor]="share"
            matTooltip="{{ 'VIDEO_DETAIL.SHARE_TIP' | translate }}"
            mat-button
            class="link-btn"
            aria-label="Example icon-button with a menu"
          >
            <span class="icon-forword"></span> Share
          </button>
          <mat-menu #share="matMenu" class="please_login">
            <div (click)="$event.stopPropagation()">
              <h4>{{ "VIDEO_DETAIL.SHARE_VIDEO" | translate }}</h4>
              <!-- <p>{{ "VIDEO_DETAIL.SIGNIN_MESSAGE" | translate }}</p> -->
              <hr />
              <a href="javascript:void(0)" (click)="singIn('share')">
                {{ "VIDEO_DETAIL.SIGN_IN" | translate }}
              </a>
            </div>
          </mat-menu>
        </div>
        <div class="social-icons">
          <button
            matTooltip="{{ 'VIDEO_DETAIL.REPORT_TIP' | translate }}"
            mat-button
            *ngIf="isLogin"
            class="report-btn"
            (click)="openReport(public_id)"
          >
            <span class="icon-flag"></span> Report
          </button>
        </div>
      </div>
    </div>

    <div class="comment_sect">
      <div
        class="head-search"
        [ngClass]="{ 'head-shadow': scrollClass == false }"
      >
        <div class="ratin-section">
          <div class="rating-box mb-0">
            {{ videoDetail?.avg_rating | number: "1.1-1" }}
            <span class="material-icons" *ngIf="videoDetail?.avg_rating">
              grade
            </span>
          </div>
          <span class="text-white">
            {{ videoDetail?.total_comment }}
            <span class="pr-2" *ngIf="videoDetail?.total_comment > 1">{{
              "VIDEO_DETAIL.REVIEWS" | translate
            }}</span>
            <span class="pr-2" *ngIf="videoDetail?.total_comment <= 1">{{
              "VIDEO_DETAIL.REVIEW" | translate
            }}</span>
          </span>
          <button
            class="btn btn-link ml-2"
            (click)="openDialog(public_id)"
            *ngIf="!videoDetail?.is_user_rating_review_status && isLogin"
          >
            {{ "VIDEO_DETAIL.ADD_COMMENT" | translate }}
          </button>
        </div>
      </div>

      <div
        #scroll
        *ngIf="videoDetail?.lastComment?.name"
        [ngClass]="{ 'more-comments': showComment }"
      >
        <div (scroll)="onScroll($event)" class="load-comments">
          <div class="d-flex comment-list" *ngIf="!isReview">
            <div class="circle min-profile">
              <img
                [src]="videoDetail?.lastComment?.image"
                src-fallback="assets/images/user.jpg"
              />
            </div>
            <div class="user-comments">
              <div class="user-name">
                <span> {{ videoDetail?.lastComment?.name | titlecase }} </span
                ><span class="seprater-dot">&nbsp;.&nbsp;</span>
                <span>{{
                  videoDetail?.lastComment?.created_at | amTimeAgo
                }}</span>
                <div class="ml-3 rating-box">
                  {{ videoDetail?.lastComment?.rating | number: "1.1-1" }}
                  <span class="material-icons"> grade </span>
                </div>
              </div>
              <p class="mb-0">
                {{ videoDetail?.lastComment?.review | capitalizes }}
              </p>
            </div>
          </div>
          <div>
            <div *ngIf="commentData?.length > 0">
              <div
                *ngFor="let comment of commentData"
                class="d-flex comment-list mb-2"
              >
                <div class="circle min-profile">
                  <img
                    [src]="comment?.image"
                    src-fallback="assets/images/user.jpg"
                  />
                </div>
                <div class="user-comments">
                  <div class="user-name">
                    <span> {{ comment?.name | titlecase }} </span>
                    <span class="seprater-dot">&nbsp;.&nbsp;</span>
                    <span>{{ comment?.created_at | amTimeAgo }}</span>
                    <div class="rating-box ml-3">
                      {{ comment.rating | number: "1.1-1" }}
                      <span class="material-icons"> grade </span>
                    </div>
                  </div>
                  <p class="mb-0">
                    {{ comment.review | capitalizes }}
                  </p>
                </div>
              </div>
            </div>
            <article
              *ngIf="commentShimmer"
              class="related-search sim-gallery my-3"
              style="padding: 0 !important"
            >
              <div class="container-fluid">
                <div class="row custome-set">
                  <div class="simmer-animation circle"></div>
                  <div class="w-75 ml-4">
                    <div class="simmer-animation simmer-name"></div>
                    <div class="simmer-animation simmer-rating"></div>
                    <div class="simmer-animation simmer-desc"></div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
        <button
          [disabled]="!buttonStatus"
          *ngIf="videoDetail?.total_comment > 1"
          class="btn view_comment less-btn"
          [ngClass]="{ 'more-btn': showComment }"
          (click)="commentToggle()"
        >
          <span class="more">{{ "VIDEO_DETAIL.MORE_COMMENT" | translate }}</span
          ><span class="less">{{
            "VIDEO_DETAIL.LESS_COMMENT" | translate
          }}</span>
          <span class="ml-1 material-icons arrow-ic"> expand_more </span>
        </button>
      </div>
    </div>
  </div>
</div>
<div class="actors_images" *ngIf="videoDetail?.cast_and_crew?.length > 0">
  <div class="section-head p-0">
    <h2>{{ "VIDEO_DETAIL.CAST_&_CREW" | translate }}</h2>
  </div>
  <div class="multipe_actores">
    <div
      class="actors_profile cursor-pointer"
      *ngFor="let crew of videoDetail?.cast_and_crew"
      [routerLink]="['/cast-crew']"
      [queryParams]="{ name: crew?.name }"
    >
      <div class="circle actor_img">
        <img [src]="crew?.image" [src-fallback]="appConstant.userNoImage" />
      </div>
      <span class="actor_name">
        {{ crew?.name | titlecase }}
      </span>
      <span class="actor_name mt-0">
        <span *ngFor="let type of crew.type; let i = index">
          {{ type | titlecase
          }}<span *ngIf="crew.type?.length !== i + 1">,</span>
        </span>
      </span>
    </div>
  </div>
</div>
